import * as Yup from 'yup';
import {
  CITY_LENGTH,
  STREET_LENGTH,
  createEmailSchema,
  createEnumSchema,
  createFirstNameFieldSchema,
  createHouseNumberSchema,
  createLastNameFieldSchema,
  createRequiredStringSchema,
  createStringFieldSchema,
  createUserIdSchema,
  createZipCodeSchema,
  getHouseNumberLengthPerCountry
} from '@spa/lib/formsSchemas/commonValidations';
import { FormatMessageFunction } from '@spa/lib/i18n/common/FormatMessageFunction';
import { Schema } from 'yup';
import { TitleCode } from '@spa/lib/converters/convertCustomerTitles';
import { ToyCatalogFormFields } from '@spa/components/toy-catalog/toyCatalogTypes';

const toyCatalogValidationSchema = (
  countryCode: string,
  formatMessage: FormatMessageFunction
): Schema<ToyCatalogFormFields> => {
  return Yup.object({
    salutation: createEnumSchema(TitleCode),
    firstName: createFirstNameFieldSchema(formatMessage),
    lastName: createLastNameFieldSchema(formatMessage),
    email: createEmailSchema(formatMessage),
    street: createStringFieldSchema(STREET_LENGTH, formatMessage),
    houseNumber: createHouseNumberSchema(
      formatMessage,
      getHouseNumberLengthPerCountry(countryCode)
    ),
    postalCode: createZipCodeSchema(countryCode, formatMessage),
    city: createStringFieldSchema(CITY_LENGTH, formatMessage),
    countryCode: createRequiredStringSchema(formatMessage),
    userId: createUserIdSchema(formatMessage)
  });
};

export default toyCatalogValidationSchema;
